import React, { useState } from 'react'
import { useRequestB2CReport } from '@/services'
import { useDialog } from '@/hooks'
import { ReportFormat, SbpReportParams } from '@/types.ts'
import { useParams } from 'react-router-dom'
import { downloadFile } from '@/utils.ts'
import { Button, Grid } from '@mui/material'
import { Form } from '@/components/form'
import { ReportRequestFormState } from '@/pages/b2c/components/b2c-report-dialog'
import { Dialog } from '@/components'
import { RadioGroup } from '@/components/radio-group.tsx'

const REPORT_FORM = 'b2cRegistryReportForm'

export const B2CRegistryUploadDataDialog = (): React.ReactElement => {
  const { mutateAsync } = useRequestB2CReport()
  const { showDialog, handleShowDialog, handleHideDialog } = useDialog()
  const [format, setFormat] = useState<ReportFormat>('xlsx')
  const { id = '' } = useParams<{ id: string }>()

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormat(event.target.value as SbpReportParams['formatReport'])
  }

  const handleReportSubmit = async () => {
    try {
      const response = await mutateAsync({
        registryId: id,
        formatReport: format,
      })

      if (response?.status === 200 && response.data) {
        const filename = response?.headers['content-disposition']?.match(/filename="([^"]+)"/i)

        downloadFile(URL.createObjectURL(response.data), filename?.[1] ?? `report_registy`)
      }
      handleHideDialog()
    } catch (axiosError) {
      console.error(axiosError)
    }
  }

  return (
    <>
      <Button onClick={handleShowDialog} variant="outlined">
        Выгрузить данные по реестру
      </Button>
      {showDialog && (
        <Form<ReportRequestFormState>
          name={REPORT_FORM}
          initialValues={{
            formatReport: 'xlsx',
            dateFrom: '',
            dateTo: '',
          }}
          onSubmit={handleReportSubmit}
        >
          <Dialog
            title={`Выгрузить данные по реестру №${id}`}
            open={showDialog}
            onClose={handleHideDialog}
            content={
              <Grid container flexDirection="column" spacing={2}>
                <Grid item>
                  <RadioGroup
                    row
                    value={format}
                    onChange={handleFormatChange}
                    label="Формат отчёта"
                    items={[
                      { title: '.xlsx', value: 'xlsx' },
                      { title: '.csv', value: 'csv' },
                    ]}
                  />
                </Grid>
              </Grid>
            }
            actions={
              <Button fullWidth onClick={handleReportSubmit}>
                Отправить заявку
              </Button>
            }
          />
        </Form>
      )}
    </>
  )
}
